/**
 * Create / Update interview mutations.
 * POST /api_ats/v1/ats_interviews
 * PUT  /api_ats/v1/ats_interviews/:id
 *
 * Payload shape will be finalised — keep loose typing for now.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/request';

export interface CreateInterviewVariables {
  payload: FormData | Record<string, unknown>;
}

export interface UpdateInterviewVariables {
  interviewId: number;
  payload: FormData | Record<string, unknown>;
}

export function useCreateInterview() {
  const queryClient = useQueryClient();

  return useMutation<Record<string, unknown>, Error, CreateInterviewVariables>({
    mutationFn: ({ payload }) =>
      api.post<Record<string, unknown>>('ats_interviews', payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['schedule-interview'] });
    },
  });
}

export function useUpdateInterview() {
  const queryClient = useQueryClient();

  return useMutation<Record<string, unknown>, Error, UpdateInterviewVariables>({
    mutationFn: ({ interviewId, payload }) =>
      api.put<Record<string, unknown>>(
        `ats_interviews/${interviewId}`,
        payload
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['schedule-interview'] });
    },
  });
}
